export const updateMaintenanceWindow = `
  mutation($startDatetime: String!, $endDatetime: String!, $maintenanceMessage: String!) {
    maintenanceWindows(startDatetime: $startDatetime, endDatetime: $endDatetime, maintenanceMessage: $maintenanceMessage) {
      startDatetime
      endDatetime
      maintenanceMessage
    }
  }
`;
